module.exports = __webpack_public_path__ + "static/assets/19824e9bde4007a19be3a1f7f7108ed7.svg";